import type { IconData } from '@stacksjs/iconify-core'

export const clearFormat: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.326 2L3.95 9.309a1 1 0 1 1-1.902-.618L4.223 2H1a1 1 0 1 1 0-2h8a1 1 0 1 1 0 2zm3.33 6.243l.708.707a1 1 0 1 1-1.414 1.414l-.707-.707l-.707.707A1 1 0 0 1 6.12 8.95l.707-.707l-.707-.707A1 1 0 0 1 7.536 6.12l.707.707l.707-.707a1 1 0 1 1 1.414 1.415z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default clearFormat
